import { useOrgSwitch } from './OrgSwitchContext'

/**
 * Full-page blocking loaders should only show on first load (no data yet),
 * not on background refetches after org switch (overlay already covered that).
 */
export function useBlockOnPendingWithoutData(isPending: boolean, hasData: boolean): boolean {
  const { isSwitching } = useOrgSwitch()
  return isPending && !hasData && !isSwitching
}
